"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SolarConstants = void 0;
class SolarConstants {
    constructor() {
        this.highEmissionFactor = 6.8;
        this.lowEmissionFactor = 1.3;
        this.emissionFactorUnit = "tCO2/MWh";
        this.thresholdUnit = "kWh/year";
        this.buildingTypes = {
            Household: 55,
            HealthCenter: 825,
            Dispensary: 825,
            School: 275,
            PrimarySchool: 275,
            SecondarySchool: 275,
            PublicAdministration: 55,
            TradingPlace: 825,
            BusStop: 200,
        };
    }
}
exports.SolarConstants = SolarConstants;
